export function FuncFactory() {
    return function Func() {
        this.id = null;
        this.code = null;
        this.name = null;
        this.desc = null;
        this.parent = null;
    };
}
